export function defaultStrategyName(asin: string, today = new Date()): string {
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${asin}${today.getFullYear()}${month}${day}`;
}
